import React, { useMemo } from 'react'

import * as S from './UploadedImage.styled'

type Props = {
  image: File | string
  objectFit?: 'contain' | 'cover'
}

export const UploadedImage = ({ image, objectFit = 'cover' }: Props) => {
  const src = useMemo(() => {
    if (typeof image === 'string') {
      return image
    }

    return URL.createObjectURL(image)
  }, [image])

  return <S.Image src={src} data-testid="UploadedImage" objectFit={objectFit} />
}
